export const GET_SIMPLE_VIEW_VEHICLE = 'GET_SIMPLE_VIEW_VEHICLE';
export const GET_SIMPLE_VIEW_VEHICLE_SUCCESS = 'GET_SIMPLE_VIEW_VEHICLE_SUCCESS';
export const GET_SIMPLE_VIEW_VEHICLE_ERROR = 'GET_SIMPLE_VIEW_VEHICLE_ERROR';